"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clips = void 0;
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
const util_1 = require("./util");
const GET_WITH_NO_WS_DEFAULTS = {
    withBoards: true,
    withAncestorsAndThumbnails: true,
    numBoardThumbnails: 1,
    withOpenDiscussionStatus: true,
};
const CLIP_LIST_DEFAULTS = {
    limit: 72,
    type: types_1.ClipsFiltersBookmarkStatus.all,
};
function search(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        const withDefaults = Object.assign(Object.assign({}, CLIP_LIST_DEFAULTS), rest);
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `search`,
            method: 'POST',
            body: withDefaults,
            workspaceId,
        });
    });
}
function searchFiles(options) {
    return __awaiter(this, void 0, void 0, function* () {
        return search(Object.assign(Object.assign({}, options), { types: types_1.ClipType.nonMedia }));
    });
}
/**
 * Creates a new clip in the remote database.
 * @param clip
 * @param boardId will automatically insert the clip into a board
 * @deprecated use getUploadUrls
 */
function create(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clip, boardId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            method: 'POST',
            body: Object.assign(Object.assign({}, clip), { boardId }),
            workspaceId,
            boardContext: boardId,
        });
    });
}
/** Returns a clip (based on the ID given) from the remote database */
function get(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, options, }) {
        const paramString = (0, querystring_1.stringify)(Object.assign({ safeGet: true }, options));
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}?${paramString}`,
            workspaceId,
            boardContext: options && options.boardId,
        });
    });
}
/**
 * Gets an asset by id  without needing a workspaceId
 * @param clipId id of clip to get
 * @param options see ClipGetOptions
 */
function getWithNoWorkspaceId(_a) {
    return __awaiter(this, arguments, void 0, function* ({ id, options, }) {
        const paramString = (0, querystring_1.stringify)(Object.assign(Object.assign({}, GET_WITH_NO_WS_DEFAULTS), options));
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${id}?${paramString}`,
            boardContext: options && options.boardId,
        });
    });
}
/** Updates clips (based on the IDs given) in the remote database */
function batchUpdate(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clips, parentBoardId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: 'batch/update',
            body: clips,
            method: 'POST',
            workspaceId,
            boardContext: parentBoardId,
        });
    });
}
function checkCanUpload(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, size, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: 'canUpload',
            method: 'POST',
            body: { size },
            workspaceId,
        });
    });
}
/** Returns a url to download a clip at (based on the ID passed) */
function getDownloadUrl(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, options, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/download?${(0, querystring_1.stringify)(options)}`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 * Returns an array of objects that associate ids with signed URLs for upload
 * @param files An array of file objects
 * @param source Source for clips
 * @param boardId All clips will be added to this board
 */
function getUploadUrls({ workspaceId, options, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.clips, {
        endpoint: `batch/upload`,
        method: 'POST',
        workspaceId,
        body: options,
    });
}
/**
 * Adds clips to db, creates multipart uploads for each file,
 * and returns a list of UploadIds that can be used to retrieve
 * urls to upload file chunks, as well as the file Key generated from
 * clipId and ext
 * @param files List of file data
 * @param source  ClipSource
 * @param boardId? The board to add clips to
 */
function createMultipartUploads({ workspaceId, options, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.clips, {
        endpoint: `batch/upload/multipart`,
        method: 'POST',
        workspaceId,
        body: options,
    });
}
/**
 * Gets a url for a chunk of a multipart upload
 * @param key the key for the part the url is being requested for
 * @param uploadId id returned from S3 after creating multipart upload
 * @param partNumber index of chunk to upload
 * @param boardId contextualizes the request for a guest editor
 */
function getPartUploadUrl({ workspaceId, key, uploadId, partNumber, options: { boardId } = {}, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.clips, {
        endpoint: `multipart`,
        method: 'POST',
        body: {
            Key: key,
            UploadId: uploadId,
            PartNumber: partNumber,
        },
        workspaceId,
        boardContext: boardId,
    });
}
/**
 * Merges the file upload parts and moves it from multipart bucket into pipeline bucket
 * @param key the key for the part the url is being requested for
 * @param uploadId id returned from S3 after creating multipart upload
 * @param parts An array of chunk indexes assigned by client and chunk identifiers returned from S3
 * @param boardId contextualizes the request for a guest editor
 */
function completeMultipartUpload({ workspaceId, key, uploadId, parts, options: { boardId } = {}, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.clips, {
        endpoint: `multipart/complete`,
        method: 'POST',
        workspaceId,
        body: {
            Key: key,
            UploadId: uploadId,
            Parts: parts,
        },
        boardContext: boardId,
    });
}
/**
 * Aborts a multipart upload and removes its corresponding parts
 * @param key the key for the part the url is being requested for
 * @param uploadId id returned from S3 after creating multipart upload
 * @param boardId contextualizes the request for a guest editor
 */
function abortMultipartUpload({ workspaceId, key, uploadId, options: { boardId } = {}, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.clips, {
        endpoint: `multipart`,
        method: 'DELETE',
        workspaceId,
        body: {
            Key: key,
            UploadId: uploadId,
        },
        boardContext: boardId,
    });
}
/**
 * Matches an array of files to existing clips in the db
 */
function matchFilesToClips({ workspaceId, files, boardId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.clips, {
        endpoint: `matchFiles`,
        method: 'POST',
        workspaceId,
        body: { files, boardId },
        boardContext: boardId,
    });
}
/**
 * API to bulk fetch clip details by provided clipIds
 */
function listByIds(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, options = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: 'listByIds',
            method: 'POST',
            workspaceId,
            body: options,
        });
    });
}
/**
 * API to query for simplified Asset/Clip information for two-way sync clients.
 * @param boardId the board to get clips from
 * @param options paging & sorting
 *
 * @deprecated use Asset.listCoverVersionsForSync
 */
function listForSync(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, options = {}, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `${boardId}/${types_1.EndpointType.clips}/listForSync?${(0, util_1.stringifyOptions)(options)}`,
            workspaceId,
        });
    });
}
/**
 * (Test Method)
 * Given a source clip id, creates a new clip in the workspace with the same properties
 * and will clone the clips original file into the pipeline bucket as the new clip's file
 * to kick off the media processing pipeline
 *
 * @param workspaceId the workspace to create the clip in
 * @param sourceClipId the clip to copy into the workspace
 * @returns newly created clip id
 */
function createFromSource(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, sourceClipId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `createFromSource`,
            method: 'POST',
            body: { sourceClipId },
            workspaceId,
        });
    });
}
/**
 * Creates captured text for a clip. This is used when OCR misses some text and a user is manually adding it.
 * @param workspaceId the workspace id
 * @param clipId The id of the clip to create captured text on
 * @param capturedText The captured text to create on the clip
 */
function createCapturedText(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, capturedText, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/capturedText`,
            method: 'POST',
            body: capturedText,
            workspaceId,
        });
    });
}
/**
 * Lists captured text for a clip
 * @param workspaceId the workspace id
 * @param clipId the id of the clip to list captured text on
 * @param cursor (optional) the cursor to use for pagination
 */
function listCapturedText(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, cursor, limit, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/capturedText?${(0, util_1.stringifyOptions)({ cursor, limit })}`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 * Updates captured text for a clip
 * @param workspaceId the workspace id
 * @param clipId the id of the clip to update captured text on
 * @param id the id of the captured text to update
 * @param update the update to apply to the captured text
 */
function updateCapturedText(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, id, update, }) {
        yield (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/capturedText/${id}`,
            method: 'PATCH',
            body: update,
            workspaceId,
        });
    });
}
/**
 * Deletes captured text for a clip
 * @param workspaceId the workspace id
 * @param clipId the id of the clip to delete captured text on
 * @param id the id of the captured text to delete
 */
function deleteCapturedText(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, id, }) {
        yield (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/capturedText/${id}`,
            method: 'DELETE',
            workspaceId,
        });
    });
}
/**
 * Lists IPTC/Exif metadata fields on a clip
 * @param workspaceId the workspace id
 * @param clipId the id of the clip to list metadata from
 * @param [cursor] the cursor to use for pagination
 * @param [limit] the number of metadata fields to return per page
 */
function listMetadata(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, cursor, limit, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/metadata?${(0, util_1.stringifyOptions)({ cursor, limit })}`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 * Get a clip's transcript information
 *
 * @param workspaceId the workspace id
 * @param clipId the id of the clip
 */
function getTranscript(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/transcript`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 * Lists segments of a clip's transcript
 *
 * @param args
 * @param args.workspaceId the workspace id
 * @param args.clipId the id of the clip to list segments from
 * @param args.startTimeMs the start time of the segment(s) to list
 * @param args.endTimeMs the end time of the segment(s) to list
 */
function listTranscriptSegments(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, startTimeMs, endTimeMs, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/transcript/segments?${(0, util_1.stringifyOptions)({
                startTimeMs,
                endTimeMs,
            })}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function searchTranscriptSegments(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, clipId, search, startTimeMs, endTimeMs, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.clips, {
            endpoint: `${clipId}/transcript/segments/search?${(0, util_1.stringifyOptions)({
                search,
                startTimeMs,
                endTimeMs,
            })}`,
            method: 'GET',
            workspaceId,
        });
    });
}
exports.Clips = {
    search,
    searchFiles,
    create,
    createFromSource,
    get,
    getWithNoWorkspaceId,
    batchUpdate,
    checkCanUpload,
    getDownloadUrl,
    listByIds,
    listForSync,
    GET_WITH_NO_WS_DEFAULTS,
    CLIP_LIST_DEFAULTS,
    getUploadUrls,
    createMultipartUploads,
    getPartUploadUrl,
    completeMultipartUpload,
    abortMultipartUpload,
    matchFilesToClips,
    createCapturedText,
    listCapturedText,
    updateCapturedText,
    deleteCapturedText,
    listMetadata,
    getTranscript,
    listTranscriptSegments,
    searchTranscriptSegments,
};
//# sourceMappingURL=clips.js.map